// extracted by mini-css-extract-plugin
module.exports = {"card":"FileDownloader_card__3YuAH"};